export const UPLOAD_USER_MEDIA_REQUEST = 'UPLOAD_USER_MEDIA_REQUEST'
export const UPLOAD_USER_MEDIA_FAILURE = 'UPLOAD_USER_MEDIA_FAILURE'
export const UPLOAD_USER_MEDIA_SUCCESS = 'UPLOAD_USER_MEDIA_SUCCESS'
export const GET_USER_MEDIA_REQUEST = 'GET_USER_MEDIA_REQUEST'
export const GET_USER_MEDIA_FAILURE = 'GET_USER_MEDIA_FAILURE'
export const GET_USER_MEDIA_SUCCESS = 'GET_USER_MEDIA_SUCCESS'
export const DELETE_USER_MEDIA_REQUEST = 'DELETE_USER_MEDIA_REQUEST'
export const DELETE_USER_MEDIA_FAILURE = 'DELETE_USER_MEDIA_FAILURE'
export const DELETE_USER_MEDIA_SUCCESS = 'DELETE_USER_MEDIA_SUCCESS'
export const UPLOAD_USER_MEDIA_RESET = 'UPLOAD_USER_MEDIA_RESET'
